import { FundProjectionScreenOutlined } from "@ant-design/icons";
import EchartsPage from "../EchartsPage"
import EchartsPageByRate from "../EchartsPageByRate"
import { DatePicker, Button } from 'antd';
import { useEffect, useState } from "react";

const { RangePicker } = DatePicker;
const { getProjectFormListAPI } = require('@/apis/form')

async function getProjectFormList(startTime, endTime) {
    let res = await getProjectFormListAPI(startTime, endTime)
    return res.data
}

const ProjectDetailForms = () => {
    const [startDateTime, setStartDateTime] = useState('')
    const [endDateTime, setEndDateTime] = useState('')
    const [showFormType, setShowFormType] = useState(true)
    const [form, setForm] = useState([])
    const handleDateChange = (dates) => {
        setStartDateTime(dates[0].format('YYYY-MM-DDTHH:mm:ss'))
        setEndDateTime(dates[1].format('YYYY-MM-DDTHH:mm:ss'))
    }
    const handleSearchButtonClick = async () => {
        setShowFormType(false)
        const formData = await getProjectFormList(startDateTime, endDateTime)
        setForm(formData)
    }

    return (
        <div>
            <div>
                <RangePicker showTime onChange={handleDateChange} />
                <Button type="primary" onClick={handleSearchButtonClick}>搜索</Button>
            </div>
            {showFormType && <EchartsPage />}
            {!showFormType && <EchartsPageByRate form={form} />}
        </div>
    )
}

export default ProjectDetailForms